import * as React from 'react';

import { cn } from '@/lib/utils';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  /** 0..100 */
  value?: number;
};

const Progress = React.forwardRef<HTMLDivElement, Props>(
  ({ className, value = 0, ...props }, ref) => {
    const clamped = Math.max(0, Math.min(100, value));
    return (
      <div
        ref={ref}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={clamped}
        className={cn('bg-muted relative h-2 w-full overflow-hidden rounded-full', className)}
        {...props}
      >
        <div
          className="bg-primary h-full transition-all duration-300"
          style={{ width: `${clamped}%` }}
        />
      </div>
    );
  },
);
Progress.displayName = 'Progress';

export { Progress };
